import http, { authHeader } from './http';

// period: '7d' | '30d' | '90d' | 'all'
export const getStats = (token, period) =>
  http.get('/api/admin/vk-bot/stats', { params: { period }, headers: authHeader(token) }).then((r) => r.data);

export const getLeads = (token, params) =>
  http.get('/api/admin/vk-bot/leads', { params, headers: authHeader(token) }).then((r) => r.data);
